import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  fallbackWebBuildMetadata,
  getWebBuildMetadata,
  WebBuildMetadata
} from '../services/buildMetadata';

type VersionIndicatorProps = {
  isAdmin: boolean;
};

export function VersionIndicator({ isAdmin }: VersionIndicatorProps) {
  const { t } = useTranslation();
  const [metadata, setMetadata] = useState<WebBuildMetadata>(fallbackWebBuildMetadata);

  useEffect(() => {
    let mounted = true;
    getWebBuildMetadata().then(value => {
      if (mounted) setMetadata(value);
    });
    return () => {
      mounted = false;
    };
  }, []);

  const version = metadata.version.startsWith('v')
    ? metadata.version
    : `v${metadata.version}`;
  const commit = metadata.commit === 'local'
    ? metadata.commit
    : metadata.commit.slice(0, 7);
  const label = `${version} · ${commit}`;

  return isAdmin ? (
    <Link
      to="/admin/system/versions"
      className="text-muted text-decoration-none"
      aria-label={`${t('versions.indicatorLabel')}: ${label}`}
    >
      {label}
    </Link>
  ) : (
    <span className="text-muted" aria-label={`${t('versions.indicatorLabel')}: ${label}`}>
      {label}
    </span>
  );
}
